import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import AdminLogin from "./AdminTools/AdminLogin";
import ControlPanel from "./AdminTools/ControlPanel";
import DeviceModule from "./AdminTools/DeviceModule";
import AdminDevices from "./AdminTools/DeviceModule/AdminDevices";
import Transfers from "./AdminTools/LifeCycleManagementModule/Transfers";
import MaintenanceModule from "./AdminTools/MaintenanceModule";
import MaintenanceTickets from "./AdminTools/MaintenanceModule/MaintenanceTickets";
import TicketArchive from "./AdminTools/MaintenanceModule/MaintenanceTickets/TicketArchive";
import MaintenanceStatistics from "./AdminTools/MaintenanceModule/Statistics";
import TicketSettings from "./AdminTools/MaintenanceModule/TicketSettings";
import ServiceItemModule from "./AdminTools/ServiceItemModule";
import SoftwareDetails from "./AdminTools/SoftwareModule";
import CrashlogDetails from "./AdminTools/SoftwareModule/CrashlogDetails";
import Crashlogs from "./AdminTools/SoftwareModule/Crashlogs";
import Releases from "./AdminTools/SoftwareModule/Releases";
import PrereleaseList from "./AdminTools/SoftwareModule/Releases/PrereleaseList";
import ReleaseList from "./AdminTools/SoftwareModule/Releases/ReleaseList";
import StockModule from "./AdminTools/StockModule";
import ModifyStock from "./AdminTools/StockModule/ModifyStock";
import StockStatistics from "./AdminTools/StockModule/StockStatistics";
import SystemDashboard from "./AdminTools/SystemModule";
import EmailLists from "./AdminTools/SystemModule/EmailLists";
import EditEmailList from "./AdminTools/SystemModule/EmailLists/EditEmailList";
import NewEmailList from "./AdminTools/SystemModule/EmailLists/NewEmailList";
import NewUser from "./AdminTools/SystemModule/NewUser";
import Users from "./AdminTools/SystemModule/Users";
import EditUser from "./AdminTools/SystemModule/Users/EditUser";
import WebstoreOrders from "./AdminTools/WebstoreOrders";
import EditWebstoreOrder from "./AdminTools/WebstoreOrders/EditWebstoreOrder";
import "./App.css";
import PopupSnackbar from "./Components/PopupSnackbar";
import AdminRoute from "./Utils/AdminRoute";
import { USER_GROUPS, getToken } from "./Utils/Common";
import PrivateRoute from "./Utils/PrivateRoute";
import PublicRoute from "./Utils/PublicRoute";
import { useStyles } from "./Utils/Styles";
import Alerts from "./Views/Alerts";
import AlertView from "./Views/Alerts/Alert";
import ChangePassword from "./Views/ChangePassword";
import Contacts from "./Views/Contacts";
import Contact from "./Views/Contacts/Contact";
import Dashboard from "./Views/Dashboard";
import DemoDevices from "./Views/DemoDevices";
import DeviceDetails from "./Views/DeviceDetails";
import Devices from "./Views/Devices";
import DispatchedDevices from "./Views/DispatchedDevices";
import Login from "./Views/Login";
import Manufacturing from "./Views/Manufacturing";
import ManufacturingFeatureLists from "./Views/Manufacturing/Features";
import FeatureItems from "./Views/Manufacturing/Features/FeatureItems";
import ManufacturingRecipes from "./Views/Manufacturing/Recipes";
import SerialisedSubAssemblies from "./Views/Manufacturing/SerialisedSubAssemblies";
import Orders from "./Views/Orders";
import ProductTransfers from "./Views/ProductTransfers";
import Production from "./Views/Production";
import ResupplyOrders from "./Views/ResupplyOrders";
import SupplierCompanies from "./Views/ResupplyOrders/SupplierCompanies";
import EditSupplierCompany from "./Views/ResupplyOrders/SupplierCompanies/EditCompany";
import SendPasswordReset from "./Views/SendPasswordReset";
import SessionDetails from "./Views/SessionDetails";
import Settings from "./Views/Settings";
import Shipments from "./Views/Shipments";
import ShippingCompanies from "./Views/Shipments/ShippingCompanies";
import EditCompany from "./Views/Shipments/ShippingCompanies/EditCompany";
import WorldMap from "./Views/WorldMap";

const adminRoutes = [
  { path: "/cpanel/alerts/:alert_id", component: AlertView },
  { path: "/cpanel/alerts", component: Alerts },
  { path: "/cpanel/contacts/:type/:id", component: Contact },
  { path: "/cpanel/contacts", component: Contacts },
  { path: "/cpanel/users/new", component: NewUser, superuser: true },
  { path: "/cpanel/users/:id", component: EditUser, superuser: true },
  { path: "/cpanel/users", component: Users, superuser: true },
  { path: "/cpanel/crashlogs/:crashlog_id", component: CrashlogDetails },
  { path: "/cpanel/crashlogs", component: Crashlogs },
  { path: "/cpanel/devices/dashboard", component: DeviceModule },
  { path: "/cpanel/devices/:device_id", component: DeviceDetails },
  { path: "/cpanel/devices", component: AdminDevices },
  { path: "/cpanel/demos", component: DemoDevices },
  { path: "/cpanel/dispatches", component: DispatchedDevices },
  {
    path: "/cpanel/emaillists/new",
    component: NewEmailList,
    superuser: true,
  },
  {
    path: "/cpanel/emaillists/:list_id",
    component: EditEmailList,
    superuser: true,
  },
  {
    path: "/cpanel/emaillists",
    component: EmailLists,
    superuser: true,
  },
  { path: "/cpanel/maintenance/ticketarchive", component: TicketArchive },
  { path: "/cpanel/maintenance/tickets", component: MaintenanceTickets },
  {
    path: "/cpanel/maintenance/statistics",
    component: MaintenanceStatistics,
  },
  {
    path: "/cpanel/maintenance/settings",
    component: TicketSettings,
    superuser: true,
  },
  { path: "/cpanel/maintenance", component: MaintenanceModule },
  {
    path: "/cpanel/manufacturing/serialisedsubassemblies",
    component: SerialisedSubAssemblies,
  },
  {
    path: "/cpanel/manufacturing/features/items",
    component: FeatureItems,
  },
  {
    path: "/cpanel/manufacturing/features",
    component: ManufacturingFeatureLists,
  },

  { path: "/cpanel/manufacturing/recipes", component: ManufacturingRecipes },
  { path: "/cpanel/manufacturing", component: Manufacturing },
  { path: "/cpanel/orders/:order_id", component: Orders },
  { path: "/cpanel/orders", component: Orders },
  { path: "/cpanel/production", component: Production },
  {
    path: "/cpanel/resupplyorders/:order_id",
    redirectionTo: (redirection) =>
      redirection.replace("resupplyorders", "resupply"),
  },
  { path: "/cpanel/resupply/suppliers/:id", component: EditSupplierCompany },
  { path: "/cpanel/resupply/suppliers", component: SupplierCompanies },
  { path: "/cpanel/resupply/:order_id", component: ResupplyOrders },
  { path: "/cpanel/resupply", component: ResupplyOrders },
  { path: "/cpanel/sessions/:session_id", component: SessionDetails },
  { path: "/cpanel/settings", component: Settings },
  {
    path: "/cpanel/software/prereleases/:device",
    component: PrereleaseList,
    superuser: true,
  },
  {
    path: "/cpanel/software/releases/:device",
    component: ReleaseList,
    superuser: true,
  },
  {
    path: "/cpanel/software/releases",
    component: Releases,
    superuser: true,
  },
  {
    path: "/cpanel/software",
    component: SoftwareDetails,
    superuser: true,
  },
  {
    path: "/cpanel/shipments/new/order/:order_id",
    component: Shipments,
  },
  {
    path: "/cpanel/shipments/new/resupply/:resupply_order_id",
    component: Shipments,
  },
  { path: "/cpanel/shipments/companies/:id", component: EditCompany },
  { path: "/cpanel/shipments/companies", component: ShippingCompanies },
  { path: "/cpanel/shipments/:shipment_id", component: Shipments },
  { path: "/cpanel/shipments", component: Shipments },
  { path: "/cpanel/stock/statistics", component: StockStatistics },
  { path: "/cpanel/stock/modify", component: ModifyStock },
  { path: "/cpanel/stock", component: StockModule },
  {
    path: "/cpanel/serviceitems",
    component: ServiceItemModule,
    superuser: true,
  },
  {
    path: "/cpanel/system",
    component: SystemDashboard,
    superuser: true,
  },
  { path: "/cpanel/transferlist", component: Transfers },
  { path: "/cpanel/transfers", component: ProductTransfers },
  { path: "/cpanel/webstore/:order_id", component: EditWebstoreOrder },
  { path: "/cpanel/webstore", component: WebstoreOrders },
  { path: "/cpanel/worldmap", component: WorldMap },
  { path: "/cpanel", component: ControlPanel },
];

const privateRoutes = [
  { path: "/worldmap", component: WorldMap },
  { path: "/dashboard", component: Dashboard },
  { path: "/devices/:device_id", component: DeviceDetails },
  { path: "/devices", component: Devices },
  {
    path: "/production",
    component: Production,
    permissionRequirements: {
      permissionlevels: [
        USER_GROUPS.ADMIN,
        USER_GROUPS.PRODUCTION,
        USER_GROUPS.SALES,
      ],
    },
  },
  {
    path: "/manufacturing",
    component: Manufacturing,
    permissionRequirements: {
      permissionlevels: [USER_GROUPS.ADMIN, USER_GROUPS.PRODUCTION],
    },
  },
  {
    path: "/contacts/:type/:id",
    component: Contact,
    permissionRequirements: {
      permissionlevels: [USER_GROUPS.ADMIN, USER_GROUPS.SALES],
    },
  },
  {
    path: "/contacts",
    component: Contacts,
    permissionRequirements: {
      permissionlevels: [USER_GROUPS.ADMIN, USER_GROUPS.SALES],
    },
  },
  { path: "/sessions/:session_id", component: SessionDetails },
  { path: "/settings", component: Settings },
  {
    path: "/transfers",
    component: ProductTransfers,
    permissionRequirements: {
      permissionlevels: [USER_GROUPS.ADMIN, USER_GROUPS.SALES],
    },
  },
  {
    path: "/demos",
    component: DemoDevices,
    permissionRequirements: {
      permissionlevels: [USER_GROUPS.ADMIN, USER_GROUPS.SALES],
    },
  },
  {
    path: "/dispatches",
    component: DispatchedDevices,
    permissionRequirements: {
      permissionlevels: [USER_GROUPS.ADMIN, USER_GROUPS.SALES],
    },
  },
  {
    path: "/orders",
    component: Orders,
    permissionRequirements: { permissionlevels: [USER_GROUPS.ADMIN] },
  },
];

const publicRoutes = [
  { path: "/reset_password/:token", component: ChangePassword },
  { path: "/renew_password", component: SendPasswordReset },
  { path: "/reset_password", component: SendPasswordReset },
  { path: "/admin_login/:redirection_path", component: AdminLogin },
  { path: "/admin_login", component: AdminLogin },
  { path: "/login/:redirection_path", component: Login },
  { path: "/login", component: Login },
];

const renderRoutes = (RouteComponent, routes) =>
  routes.map(({ path, ...routeProps }) => (
    <RouteComponent key={path} path={path} {...routeProps} />
  ));

export default function App(props) {
  const classes = useStyles();
  useEffect(() => {
    setTimeout(() => {
      // This timeout triggers after 25 hours and makes sure that when the token expires the user is forced to relogin
      window.location.reload();
    }, 1000 * 60 * 60 * 25);
  }, []);
  return (
    <React.Fragment>
      <PopupSnackbar />
      <div className={classes.root}>
        <Switch>
          <Route exact path="/">
            {getToken() ? (
              <Redirect to={{ pathname: "/dashboard" }} />
            ) : (
              <Redirect to={{ pathname: "/login" }} />
            )}
          </Route>
          {renderRoutes(AdminRoute, adminRoutes)}
          {renderRoutes(PrivateRoute, privateRoutes)}
          {renderRoutes(PublicRoute, publicRoutes)}
        </Switch>
      </div>
    </React.Fragment>
  );
}
